import {
  FieldVisitObjStore,
  FieldVisitProgressObjStore,
  FieldVisitNoteObjStore,
  FieldVisitPlanObjStore,
  FieldObjStore,
  FieldVisitHistoricalObjStore,
  FieldVisitProgressHistoricalObjStore
} from '@mytypes/local';
import Dexie, { type EntityTable } from 'dexie';

const db = new Dexie('invision-mobile') as Dexie & {
  fieldVisits: EntityTable<FieldVisitObjStore, 'id'>;
  fieldVisitsHistorical: EntityTable<FieldVisitHistoricalObjStore, 'id'>;
  fieldVisitsProgress: EntityTable<FieldVisitProgressObjStore, 'id'>;
  fieldVisitsProgressHistorical: EntityTable<FieldVisitProgressHistoricalObjStore, 'id'>;
  fieldVisitNotes: EntityTable<FieldVisitNoteObjStore, 'id'>;
  fieldVisitPlans: EntityTable<FieldVisitPlanObjStore, 'id'>;
  fields: EntityTable<FieldObjStore, 'id'>;
};

const fieldVisitsIndex =
  'id++, clientId, clientName, createdAt, fieldId, fieldName, label, pages, protocolId, protocolName, savedValues, stepId, trialId, trialName, updatedAt, complete';
const fieldVisitProgressIndex =
  '++id, fieldId, fieldName, growerName, pages, protocolId, protocolName, savedValues, stepId, stepName, trialId, trialName, url, boundaries, trialProducts';
db.version(7).stores({
  fieldVisits: fieldVisitsIndex,
  fieldVisitsHistorical: fieldVisitsIndex + ', lastTouched, [clientId+fieldId+stepId+trialId]',
  fieldVisitsProgress: fieldVisitProgressIndex,
  fieldVisitsProgressHistorical: fieldVisitProgressIndex + ', lastTouched, [fieldId+stepId+trialId]',
  fieldVisitNotes: '++id, createdAt, date, fieldId, files, id, latitude, longitude, note, protocolId, updatedAt, zoneId, title, stepId, localId',
  fieldVisitPlans: '++id, createdAt, date, fields, name, updatedAt',
  fields:
    '++id, boundaries, clientId, clientName, createdAt, fieldId, fieldName, growerId, planId, planName, protocolId, protocolName, plans, trialId, trialName, updatedAt, visits, trialProducts'
});

async function clearDbData() {
  const tableNames = db.tables.map(table => table.name);
  for (const tableName of tableNames) {
    await db.table(tableName).clear();
  }
  console.log('All data cleared from all tables.');
}

export { db, clearDbData };
